// common/schemas/collections/dashboardconfigs.js
import { z } from "zod";

const DashboardConfigSchema = z.object({
    userId: z.string(),
    config: z.object({
        tabs: z.array(z.object({
            id: z.string(),
            title: z.string(),
            active: z.boolean(),
            widgets: z.array(z.any()) // We use z.any() because widget configs are dynamic
        })),
        activeTabId: z.string().nullable(),
        nextWidgetId: z.number(),
        nextTabId: z.number()
    }),
     createdAt: z.date().optional(),
     updatedAt: z.date().optional(),
});

export default DashboardConfigSchema;